async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    const hiddenInput = document.createElement("input");
    hiddenInput.style.display = "none";
    hiddenInput.value = text;
    document.body.appendChild(hiddenInput);
    hiddenInput.focus();
    hiddenInput.select();
    try {
      const succeeded = document.execCommand("copy");
      if (!succeeded) {
        throw Error(
          `Copy-to-clipboard fallback failed. Original error: ${error instanceof Error ? error.message : error}`
        );
      }
    } finally {
      document.body.removeChild(hiddenInput);
    }
  }
}
function pageWasReloaded() {
  try {
    if (window.performance.getEntriesByType) {
      const reloadType = "reload";
      return window.performance.getEntriesByType("navigation").map((entry) => entry.type).includes(reloadType);
    }
    return window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD;
  } catch (error) {
    return false;
  }
}
function removeQueryParameters(keys) {
  const url = new URL(window.location.href);
  for (const key of keys) {
    url.searchParams.delete(key);
  }
  const newUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, document.title, newUrl);
}
export {
  copyToClipboard,
  pageWasReloaded,
  removeQueryParameters
};
